<template>
  <div class="basic_wrap" style="background: #f8f8f8;">
    <div class="red_top_bg">
      <div class="back_left" @click="$router.back()"></div>
      <div class="big_tit">{{$t('financial.name')}}</div>
    </div>
    <section data-v-ec99165c="" class="page-main mt-20">
      <div data-v-ecaca2b0="" data-v-ec99165c="" id="outer-f6kmz" class="_v-container" style="top: 0.5rem;">

        <div style="">

          <div class="list" v-for="(item,index) in data">
            <div style="display: flex;width: 100%;">
              <div style="width: 80%;margin-bottom: 15px;">
                <div style="font-size: 14px;font-weight: bold;color: #000;margin-bottom: 10px;">{{item.name}} -
                  {{item.day}}{{$t('day')}} - {{item.bili*100}} %
                </div>
                <div style="font-size: 11px;color: #000;margin-bottom: 10px">{{$t('financial.investment_time')}}:{{item.addtime}}
                </div>
                <div style="font-size: 11px;color: #000;">{{$t('financial.expire_date')}}:{{item.endtime}}
                </div>
              </div>
              <div style="text-align: right;width: 20%;">
                  <span v-if="item.is_sy==0" class="icon-icon-29"></span>
                  <span v-else-if="item.is_sy==1" class="icon-icon-13"></span>
                  <span v-else class="icon-icon-20"></span>
              </div>
            </div>
            <hr/>
            <div style="display: flex;width: 100%;margin-top: 16px;">
              <span style="color: #000;font-size: 14px;font-weight: bold;">{{$t('financial.deposite_amount')}}:&nbsp;{{item.num}}</span>
            </div>

            <div style="display: flex;width: 100%;color: #a4a4a4;margin-top: 10px;">
                <div v-if="item.is_sy==0">{{$t('financial.expected_revenue')}}:&nbsp;<span class="gray">{{item.yuji_num}}</span></div>
                <div v-else-if="item.is_sy==1">{{$t('financial.actual_income')}}:&nbsp;<span class="green">{{item.real_num}}</span></div>
                <div v-else>{{$t('financial.actual_income')}}:&nbsp;<span class="red">{{item.real_num}}</span></div>
            </div>

              <div v-if="item.is_sy==0" style="display: flex;width: 100%;justify-content: flex-end;">
                <div class="takeout" @click="doTakeOut(item.id)">{{$t('financial.take_out')}}</div>
              </div>
          </div>

        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import Fetch from "../../utils/fetch";

  export default {
    name: "lists",
    data() {
      return {
        lang: this.$i18n.locale || "en_us",
        data: []
      };
    },
    created() {
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        Fetch('/financial/lists').then(r => {
          this.data = r.data;
          for (let i=0;i<this.data.length;i++){
            this.data[i].addtime=this.convertDate(this.data[i].addtime);
            this.data[i].endtime=this.convertDate(this.data[i].endtime);
          }
        })
      },
      doTakeOut(id){
        Fetch('/financial/takeOut', {
          id: id,
        }).then(r => {
          console.log(r);
          if (r.code == 1) {
            this.$toast({
              background: '#07c160',
              message: r.info
            });
            this.getData();
          } else {
            this.$toast({
              background: 'red',
              message: r.info
            });
          }
        })
      },
      convertDate(timestamp){
        var date = new Date(timestamp * 1000);  // 参数需要毫秒数，所以这里将秒数乘于 1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds();
        return Y+M+D+h+m+s;
      },
    }
  }
</script>

<style lang="less" scoped>
  #app {
    background: #f8f8f8 !important;
  }

  .basic_wrap {
    background: #f8f8f8 !important;
  }

  .red_top_bg {
    background: #76b900;
  }

  .page-main {
    padding-bottom: 0;
    position: absolute;
    background: #f8f8f8!important;
    width: 100%;
  }

  .page {
    margin: 20px;
  }

  .list {
    width: 100%;
    align-items: center;
    /* padding: 10px 0px; */
    /* margin: 0; */
    /* border-bottom: solid 1px #cacaca; */
    color: #3da5d7;
    background: #fff;
    border-radius: 5px;
    padding: 16px;
  }

  .list {
    width: 100%;
    margin-top: 0.11rem;
  }

  hr {
    border: none;
    height: 1px;
    background-color: #d6dfff;
  }

  .nav span, .list span {
    flex: 1;
    /* text-align: center; */
  }

  .takeout {
    line-height: 45px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    width: 130px;
    height: 45px;
    border-radius: 23px;
    background-color: #76b900;
    margin-top: 20px;
  }
</style>
